<template>
  <div class="flex flex-col gap-4">
    <div class="text-2xl text_color">Invoices</div>

    <div v-if="loading" class="flex flex-col items-center justify-center gap-2 mt-20">
      <CustomLoader :size="28" />
    </div>
    <div v-else>
      <CustomTable
        v-if="invoices.length > 0"
        :headers="headers"
        :data="invoices"
        :pagination="pagination"
        :quick-actions="quickActions"
        :show-actions-column="true"
        :show-actions-header="false"
        :add-side-border="true"
        :show-sort="false"
        height="calc(100vh - 270px)"
        @update:pagination="handlePageChange"
      />
      <div v-else class="flex flex-col items-center justify-center gap-2 mt-20">
        <img :src="imagePath.emptyScreen" alt="empty_icon" class="size-20" />
        <span class="text-base secondary_color">No invoices yet!</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import CustomTable from '@/components/custom/CustomTable.vue';
import imagePath from '@/javascript/imagePath';
import CustomLoader from '@/components/custom/CustomLoader.vue';
import { message } from 'ant-design-vue';

const loading = ref(false);
const invoices = ref([]);
const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
});

const quickActions = computed(() => [
  {
    id: 'download',
    tooltip: 'Download Invoice',
    handler: (row) => downloadInvoice(row),
    icon: imagePath.downloadIcon,
  },
]);

const downloadInvoice = (record) => {
  if (!record.download_link) {
    message.error('Download link not available for this invoice');
    return;
  }

  const link = document.createElement('a');
  link.href = record.download_link;
  link.download = `Invoice-${record.invoice_id}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const headers = [
  { label: 'Invoice Number', key: 'invoice_id', width: 3 },
  { label: 'Date of issue', key: 'date', width: 3 },
  { label: 'Status', key: 'status', width: 3 },
  { label: 'Amount', key: 'amount', width: 3 },
];

const handlePageChange = (newPagination) => {
  pagination.value = newPagination;
  fetchInvoices();
};

const fetchInvoices = async () => {
  loading.value = true;

  setTimeout(() => {
    invoices.value = [
      { invoice_id: '#43876546', date: '12 Feb 2025', status: 'Unpaid', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876545', date: '12 Jan 2025', status: 'Overdue', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876544', date: '12 Dec 2024', status: 'Paid', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876543', date: '12 Nov 2024', status: 'Paid', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876542', date: '12 Oct 2024', status: 'Paid', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876541', date: '12 Sep 2024', status: 'Paid', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876541', date: '12 Aug 2024', status: 'Paid', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876541', date: '12 Jul 2024', status: 'Paid', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876541', date: '12 Jun 2024', status: 'Paid', amount: '$5660.00', download_link: '' },
      { invoice_id: '#43876541', date: '12 May 2024', status: 'Paid', amount: '$5660.00', download_link: '' },
    ];
    pagination.value.total = invoices.value.length;
    loading.value = false;
  }, 1000);
};

onMounted(async () => {
  await fetchInvoices();
});
</script>
